<template lang="pug">
  div.sizes(:data-space="space")
    InputSize(:itm="sizes[0]",@change="wdChange",@blur="blur")
    InputSize(:itm="sizes[1]",@change="htChange",@blur="blur")
    InputSize(:itm="sizes[2]",@change="dpChange",@blur="blur")
</template>

<script>
import InputSize from './InputSize.vue';
export default {
  name: 'Header',
  components: {
    InputSize
  },
  data () {
    return {
      timer: {},
      set: {},
      space: [],
      sizes: [
        {
          id: 0,
          tit: '横幅',
          val: 0,
          alert: false,
          min: 480,
          max: 3645
        },
        {
          id: 1,
          tit: '高さ',
          val: 0,
          alert: false,
          min: 850,
          max: 3000
        },
        {
          id: 2,
          tit: '奥行',
          val: 0,
          alert: false,
          min: 350,
          max: 1000
        }
      ]
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      let me = this;
      if (me.sets[me.number] !== undefined) {
        me.set = me.sets[me.number];
        me.space = me.set.space;
        me.sizes[0].val = me.set.space[0];
        me.sizes[1].val = me.set.space[1];
        me.sizes[2].val = me.set.space[2];
        me.timer = setTimeout(function () {
          me.checkAlert();
        }, 500);
      }
    },
    checkAlert () {
      let me = this;
      // 横幅
      let alertWidth = me.set.fix[0] + me.set.left - (me.set.fix[0] - me.set.size[0]) / 2;
      if (alertWidth * 10 > me.set.space[0]) {
        me.sizes[0].alert = true;
      } else {
        me.sizes[0].alert = false;
      }
      // 高さ
      let set = me.set.size[1] + me.set.size[3] + me.set.size[4];
      if (set > me.set.space[1] / 10) {
        me.sizes[1].alert = true;
      } else {
        me.sizes[1].alert = false;
      }
      if (me.set.fix[2] * 10 > me.set.space[2]) {
        me.sizes[2].alert = true;
      } else {
        me.sizes[2].alert = false;
      }
      let flg = false;
      for (let prop in me.sizes) {
        if (me.sizes[prop].alert) {
          flg = true;
        }
      }
      me.$set(me.set, 'alert', flg);
    },
    blur (i, num) {
      let size = this.sizes[i];
      if (size.min > num) {
        size.val = size.min;
      }
      if (size.max < num) {
        size.val = size.max;
      }
      if (i === 1) {
        this.space.splice(1, 1, size.val);
      } else {
        this.set.space.splice(i, 1, size.val);
      }
      this.sets.splice(this.number, 1, this.set);
    },
    wdChange (num) {
      this.set.space.splice(0, 1, num);
      this.sets.splice(this.number, 1, this.set);
    },
    htChange (num) {
      this.space.splice(1, 1, num);
      this.sets.splice(this.number, 1, this.set);
    },
    dpChange (num) {
      this.set.space.splice(2, 1, num);
      this.sets.splice(this.number, 1, this.set);
    }
  },
  created () {
    if (this.sets[this.number] !== undefined) {
      this.set = this.sets[this.number];
      this.space = this.sets[this.number].space;
    }
  },
  mounted () {
  }
};
</script>

<style lang="stylus">
  .sizes
    display flex
    align-items center
</style>



// WEBPACK FOOTER //
// src/components/header/Sizes.vue